// extracted by mini-css-extract-plugin
export default {"answer-grid":"style_answer-grid__r4yOg","answer-grid-large":"style_answer-grid-large__aFG8C"};